/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Object Type version store implementation of the PickerStore.
 */
'use strict';

angular
  .module('stores.picker.objecttype', [])
  .factory('ObjectTypePickerStore', function (PickerStore, $filter, $q, NG_DATE_FORMATS, sObjectUtils) {
    /**
     * The ObjectTypePickerStore.  It will create a picker store specific to a object type versions.
     * @constructor
     */
    var ObjectTypePickerStore = function () {
      PickerStore.apply(this, arguments);
      this.nextTooltipText = $filter('i18n')('NEXT_VERSION');
      this.previousTooltipText = $filter('i18n')('PREVIOUS_VERSION');
      this.latestLabel = $filter('i18n')('LATEST_VERSION');

      // Only load the latest version on sObjectUtils if there is not currently a valid version.
      if (_.isEmpty(sObjectUtils.currentVersion)) {
        sObjectUtils.getLatestVersion();
      }
    };

    ObjectTypePickerStore.prototype = new PickerStore();
    ObjectTypePickerStore.prototype.name = 'ObjectTypePickerStore';

    // Override all necessary functions from the PickerStore.
    /**
     * @overrides {@link PickerStore.getNext}
     */
    ObjectTypePickerStore.prototype.getNext = function () {
      return sObjectUtils.getNextVersion();
    };

    /**
     * @overrides {@link PickerStore.getPrevious}
     */
    ObjectTypePickerStore.prototype.getPrevious = function () {
      return sObjectUtils.getPreviousVersion();
    };

    /**
     * @overrides {@link PickerStore.getLatest}
     */
    ObjectTypePickerStore.prototype.getLatest = function () {
      return sObjectUtils.getLatestVersion();
    };

    /**
     * @overrides {@link PickerStore.getByDate}
     */
    ObjectTypePickerStore.prototype.getByDate = function (dateOfInterest) {
      return sObjectUtils.getVersionByDate(dateOfInterest);
    };

    /**
     * @overrides {@link PickerStore.getMin}
     */
    ObjectTypePickerStore.prototype.getMin = function () {
      return sObjectUtils.newestLastModified;
    };

    /**
     * @overrides {@link PickerStore.getMax}
     */
    ObjectTypePickerStore.prototype.getMax = function () {
      return sObjectUtils.oldestLastModified;
    };

    /**
     * @overrides {@link PickerStore.previousDisabled}
     */
    ObjectTypePickerStore.prototype.previousDisabled = function () {
      var currentVersion = sObjectUtils.currentVersion;
      return currentVersion && sObjectUtils.index === 0;
    };

    /**
     * @overrides {@link PickerStore.nextDisabled}
     */
    ObjectTypePickerStore.prototype.nextDisabled = function () {
      var currentVersion = sObjectUtils.currentVersion;
      return currentVersion && sObjectUtils.versions && sObjectUtils.index === sObjectUtils.versions.length - 1;
    };

    /**
     * @overrides {@link PickerStore.setupDateTimeListener}
     */
    ObjectTypePickerStore.prototype.setupDateTimeListener = function ($scope) {
      $scope.$watch(
        function () {
          return sObjectUtils.currentVersion;
        },
        function () {
          if (sObjectUtils.currentVersion && sObjectUtils.currentVersion.noVersion === true) {
            $scope.format = NG_DATE_FORMATS.SHORT;
          } else if (sObjectUtils.currentVersion) {
            $scope.dt = sObjectUtils.currentVersion.lastModified;
            $scope.format = NG_DATE_FORMATS.LONG;
          }
        },
        true
      );
    };

    return ObjectTypePickerStore;
  });
